import moment from 'moment';
import { toBuddhistYear } from './buddhist-year';

const nullSafer = text => {
  if (!text) return 'ไม่ระบุ';
  return text;
};

const textRefactor = (text, size) => {
  return `${text
    .split(' ')
    .slice(0, size)
    .join(' ')}...`;
};

const dateString = (date, locale = 'th') => {
  const momentDate = moment(date).locale(locale);
  return toBuddhistYear(momentDate, 'DD MMM YYYY');
};

const matchAgeRange = (date, gradeLevel) => {
  const levels = {
    NURSERY: { min: 0, max: 3 },
    PRE_KINDER1: { min: 3, max: 4 },
    PRE_KINDER2: { min: 4, max: 5 },
    KINDERGARTEN: { min: 5, max: 6 },
  };
  const selectedGradeLevel = levels[gradeLevel];
  const birthDate = moment(date);
  const today = moment();
  const years = moment.duration(today.diff(birthDate)).asYears();
  return years >= selectedGradeLevel.min && years <= selectedGradeLevel.max;
};

const fulldateString = (date, locale = 'th') => {
  const momentDate = moment(date).locale(locale);
  return toBuddhistYear(momentDate, 'D MMMM YYYY');
};

const getAddressLine = address => {
  if (!address) return 'ไม่ระบุที่อยู่';
  const { subDistrict, district, province } = address;
  return `ตำบล ${nullSafer(subDistrict)} อำเภอ ${nullSafer(district)} จังหวัด ${nullSafer(province)}`;
};

const getStudentAgeString = student => {
  return moment(student.dateOfBirth)
    .locale('th')
    .fromNow()
    .replace('ที่แล้ว', '');
};

const getAgeString = dateOfBirth => {
  return moment(dateOfBirth)
    .locale('th')
    .fromNow()
    .replace('ที่แล้ว', '');
};

const getGradeLevelTitle = gradeLevel => {
  switch (gradeLevel) {
    case 'NURSERY':
      return 'ปฐมวัย (อายุต่ำกว่า 3 ปี)';
    case 'PRE_KINDER1':
      return 'ปฐมวัย (อายุ 3-4 ปี)';
    case 'PRE_KINDER2':
      return 'ปฐมวัย (อายุ 4-5 ปี)';
    case 'KINDERGARTEN':
      return 'ปฐมวัย (อายุ 5-6 ปี)';
    default:
      return 'ไม่มีข้อมูล';
  }
};

const genderPrifix = gender => {
  let result = '';
  if (gender.toUpperCase() == 'MALE') {
    result = 'เด็กชาย ';
  } else if (gender.toUpperCase() == 'FEMALE') {
    result = 'เด็กหญิง ';
  }
  return result;
};

const calculateAge = date => {
  const today = new Date();
  const birthDate = new Date(date);
  var age = today.getFullYear() - birthDate.getFullYear();
  const month = today.getMonth() - birthDate.getMonth();

  if (month < 0 || (month === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }

  return age;
};

const getStudentAgeObject = date => {
  const today = new Date();
  const birthday = new Date(date);
  const d1 = moment(today);
  const d2 = moment(birthday);
  const year = d1.diff(d2, 'year');
  const month = d1.diff(d2, 'month') % 12;
  return {
    year,
    month,
  };
};

const getStudentAge = student => {
  return calculateAge(student.dateOfBirth);
};

const genderThai = gender => {
  let result = '';
  if (gender.toUpperCase() == 'MALE') {
    result = 'ชาย';
  } else if (gender.toUpperCase() == 'FEMALE') {
    result = 'หญิง';
  }
  return result;
};

const chartLinearGradient = (canvas, height, color) => {
  const ctx = canvas.getContext('2d');
  const gradient = ctx.createLinearGradient(0, 0, 0, height);
  gradient.addColorStop(0, `${color.start}`);
  gradient.addColorStop(1, `${color.end}`);
  return gradient;
};

// Custom Tooltip
const customTooltips = function(tooltip) {
  // Tooltip Element
  let tooltipEl = document.querySelector('.chartjs-tooltip');

  if (!this._chart.canvas.closest('.parentContainer').contains(tooltipEl)) {
    tooltipEl = document.createElement('div');
    tooltipEl.className = 'chartjs-tooltip';
    tooltipEl.innerHTML = '<table></table>';

    document.querySelectorAll('.parentContainer').forEach(el => {
      if (el.contains(document.querySelector('.chartjs-tooltip'))) {
        document.querySelector('.chartjs-tooltip').remove();
      }
    });

    this._chart.canvas.closest('.parentContainer').appendChild(tooltipEl);
  }

  // Hide if no tooltip
  if (tooltip.opacity === 0) {
    tooltipEl.style.opacity = 0;
    return;
  }

  // Set caret Position
  tooltipEl.classList.remove('above', 'below', 'no-transform');
  if (tooltip.yAlign) {
    tooltipEl.classList.add(tooltip.yAlign);
  } else {
    tooltipEl.classList.add('no-transform');
  }

  function getBody(bodyItem) {
    return bodyItem.lines;
  }

  // Set Text
  if (tooltip.body) {
    const titleLines = tooltip.title || [];
    const bodyLines = tooltip.body.map(getBody);

    let innerHtml = '<thead>';

    titleLines.forEach(function(title) {
      innerHtml += `<div class='tooltip-title'>${title}</div>`;
    });
    innerHtml += '</thead><tbody>';

    bodyLines.forEach(function(body, i) {
      const colors = tooltip.labelColors[i];
      let style = `background:${colors.backgroundColor}`;
      style += `; border-color:${colors.borderColor}`;
      style += '; border-width: 2px';
      style += '; border-radius: 30px';
      const span = `<span class="chartjs-tooltip-key" style="${style}"></span>`;
      innerHtml += `<tr><td>${span}${body}</td></tr>`;
    });

    innerHtml += '</tbody>';

    const tableRoot = tooltipEl.querySelector('table');
    tableRoot.innerHTML = innerHtml;
  }

  const positionY = this._chart.canvas.offsetTop;
  const positionX = this._chart.canvas.offsetLeft;
  const toolTip = document.querySelector('.chartjs-tooltip');
  const toolTipHeight = toolTip.clientHeight;

  // Display, position, and set styles for font

  tooltipEl.style.opacity = 1;
  tooltipEl.style.left = `${positionX + tooltip.caretX}px`;
  tooltipEl.style.top = `${positionY +
    tooltip.caretY -
    (tooltip.caretY > 10 ? (toolTipHeight > 100 ? toolTipHeight + 5 : toolTipHeight + 15) : 70)}px`;
  tooltipEl.style.fontFamily = tooltip._bodyFontFamily;
  tooltipEl.style.fontSize = `${tooltip.bodyFontSize}px`;
  tooltipEl.style.fontStyle = tooltip._bodyFontStyle;
  tooltipEl.style.padding = `${tooltip.yPadding}px ${tooltip.xPadding}px`;
};

export {
  textRefactor,
  dateString,
  chartLinearGradient,
  customTooltips,
  genderPrifix,
  genderThai,
  calculateAge,
  getStudentAge,
  getStudentAgeString,
  getAgeString,
  getGradeLevelTitle,
  getStudentAgeObject,
  getAddressLine,
  fulldateString,
  matchAgeRange,
  nullSafer,
};
